if (afiworkerp.require) {
	afiworkerp.require("file_uploader.bundle.js");
} else {
	afiworkerp.ready(function () {
		afiworkerp.require("file_uploader.bundle.js");
	});
}
